import { useEffect, useState } from 'react';

import PostHog from '../lib/utils/posthog';

// A null flag skips evaluation when the experiment's UI is not displayed.
export default function usePostHogVariant(flag) {
  const [variant, setVariant] = useState(() =>
    flag ? new PostHog().getFeatureFlag(flag) : null
  );

  useEffect(() => {
    if (!flag) {
      setVariant(null);
      return;
    }

    const posthog = new PostHog();
    const updateVariant = () => setVariant(posthog.getFeatureFlag(flag));
    updateVariant();
    const unsubscribe = posthog.onFeatureFlags(updateVariant);

    return typeof unsubscribe === 'function' ? unsubscribe : undefined;
  }, [flag]);

  return variant;
}
